const { createProxyMiddleware } = require('http-proxy-middleware');
module.exports = function (app) {
    app.use(createProxyMiddleware('/apt',{
        target:'http://localhost:8002',
        headers: {
            "Connection": "keep-alive"
        },
        secure:false,
        changeOrigin: true,
        pathRewrite:{
            "^/apt":"" 
        }
    }));
    app.use(createProxyMiddleware('/api',{
        target:'https://localhost:8005',
        headers: {
            "Connection": "keep-alive"
        },
        changeOrigin: true,
        secure:false,
        pathRewrite:{
            "^/api":"" 
        }
    }));
    /*app.use(createProxyMiddleware('/apt', {
        target: 'https://ibobby-stg.ai.hinet.net/',
        headers: {
            "Connection": "keep-alive"
        },
        changeOrigin: true,
        secure: false,
        pathRewrite: {
            // "^/apt":"" 
        }
    }));
    app.use(createProxyMiddleware('/api', {
        target: 'https://ibobby-stg.ai.hinet.net/',
        headers: {
            "Connection": "keep-alive"
        },
        changeOrigin: true,
        secure: false,
        pathRewrite: {
            // "^/api":"" 
        }
    }));*/
    /*app.use(createProxyMiddleware('/apt',{
         target:'https://ibobby.ai.hinet.net/',
         headers: {
             "Connection": "keep-alive"
         },
         changeOrigin: true,
         secure:false,
         pathRewrite:{
            // "^/apt":"" 
         }
     }));
    app.use(createProxyMiddleware('/api',{
        target:'https://ibobby.ai.hinet.net/',
        headers: {
            "Connection": "keep-alive"
        },
        changeOrigin: true,
        secure:false,
        pathRewrite:{
        // "^/api":"" 
        }
    }));*/
};